import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'
import { MediaLibraryEssence } from '@/types/mediaLibrary'

const setLoading: Mutation<MediaLibraryState> = (
  state,
  { essence, loading }: { essence: MediaLibraryEssence; loading: boolean }
) => {
  const mediaLibrary = new Map(state.value)
  const mediaLibraryItem = mediaLibrary.get(essence)

  if (mediaLibraryItem) {
    mediaLibraryItem.loading = loading

    state.value = mediaLibrary
  }
}

export default setLoading
